import { useEffect } from "react";

import { Notification } from "@shared/interfaces";
import { toaster } from "@shared/components/Toaster";

export default function useNotification(notification: Notification | null) {
  useEffect(() => {
    if (notification) {
      toaster.create({
        title: notification.appearance.toUpperCase(),
        description: notification.message,
        type: notification.appearance,
        duration: 5000,
        closable: true,
      });
    }
  }, [notification]);
}
